import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TokenModel } from 'src/app/core/domain/token.model';
import { SingleD1000ResponseModel } from 'src/app/core/utils/single-d1000-response-model';
import { BaseHttpService } from 'src/app/services/http/base-http.service';
import { TokenWebEntity } from './token-web-entity';
import { TokenWebRepositoryMapper } from './token-web-repository-mapper';
import { TokenRepository } from '../../../core/repositories/token.repository';
import { AutenticacaoWebRepositoryMapper } from '../autenticacao-web-reporitory/autenticacao-web-repository-mapper';
import { AutenticacaoModel } from 'src/app/core/domain/autenticacao.model';
import { RoutesService } from 'src/app/services/routing/routes.service';

@Injectable({
  providedIn: 'root',
})
export class TokenWebRepository extends TokenRepository {
  mapper = new TokenWebRepositoryMapper();
  autenticacaoMapper = new AutenticacaoWebRepositoryMapper();

  constructor(public http: BaseHttpService, public routes: RoutesService) {
    super();
  }

  postLogin(param: AutenticacaoModel): Observable<SingleD1000ResponseModel<TokenModel>> {
    var request = this.http
      .post<SingleD1000ResponseModel<TokenWebEntity>>(
        `${this.routes.TOKEN.token}`,
        this.autenticacaoMapper.mapTo(param)
      )
      .pipe(
        map((x) => {
          return this.mapper.responseWebMapFrom(x.data);
        })
      );

    return request;
  }
}
